import React from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  breadcrumb,
  className = "",
}) => {
  return (
    <div className={`py-2 ${className}`}>
      {breadcrumb && (
        <div className="mb-4">
          {breadcrumb}
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
        <div className="flex-1 min-w-0">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-fg-bright truncate leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <div className="mt-3 text-base text-fg-muted">
              {subtitle}
            </div>
          )}
        </div>
        
        {actions && (
          <div className="flex-shrink-0 w-full sm:w-auto">
            <div className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3">
              {actions}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;